<div
  class="w-full rounded-2xl bg-linear-(--my-gradient1) border-[#D9D9D9] shadow-(--my-shadow) pt-8 lg:pt-15 px-2 lg:px-5 mb-4 mb-md-0">
  <p class="text-white font-bold text-xl md:text-2xl lg:text-4xl xl:text-[45px] capitalize text-center mb-1">Welcome,
  </p>
  <p class="text-white font-normaltext-lg md:text-xl lg:text-2xl xl:text-3xl text-center">Please log in to continue</p>
  <div class="bg-white mt-6 lg:mt-10 w-full rounded-xl">

    <div class="border-b border-[#D9D9D9]">
      <ul class="flex flex-wrap -mb-px text-sm md:text-[17px] xl:text-[18px] font-medium text-center"
        id="default-styled-tab" data-tabs-toggle="#default-styled-tab-content"
        data-tabs-active-classes="text-sm md:text-lg xl:text-xl text-c19725 hover:text-c19725 font-bold border-b-3 border-c19725"
        data-tabs-inactive-classes="text-444 hover:text-gray-600 font-normal border-gray-100 hover:border-gray-300"
        role="tablist">

        <li class="w-1/3" role="presentation">
          <button class="w-full inline-block h-full p-4 rounded-t-lg cursor-pointer" id="login-styled-tab"
            data-tabs-target="#styled-login" type="button" role="tab" aria-controls="login"
            aria-selected="false">Login</button>
        </li>

        <li class="w-1/3 border-x border-[#D9D9D9]" role="presentation">
          <button class="w-full inline-block h-full p-4 rounded-t-lg cursor-pointer hover:text-gray-600"
            id="login-otp-styled-tab" data-tabs-target="#styled-login-otp" type="button" role="tab"
            aria-controls="login-otp" aria-selected="false">Login By OTP</button>
        </li>

        <li class="w-1/3" role="presentation">
          <button class="w-full inline-block h-full p-4 rounded-t-lg cursor-pointer hover:text-gray-600"
            id="fingure-scan-styled-tab" data-tabs-target="#styled-fingure-scan" type="button" role="tab"
            aria-controls="fingure-scan" aria-selected="false">Finger Scan</button>
        </li>
      </ul>
    </div>

    <div id="default-styled-tab-content">
      <div class="hidden p-4 md:py-8 md:px-10 xl:py-10 xl:px-20 rounded-lg bg-white" id="styled-login" role="tabpanel"
        aria-labelledby="login-tab">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <p class="text-444 font-bold text-base md:text-xl xl:text-2xl mb-4 lg:mb-8">Login your account</p>


          <div class="w-full flex justify-center mt-4 mb-2">
            <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4">

              <app-custom-select label="Select User Type" [options]="UserType" formControlName="user_type"
                [(selected)]="selectedUser" selectId="customerType">
              </app-custom-select>

              <!-- Validation Error -->
              <div *ngIf="loginForm.get('user_type')?.touched && loginForm.get('user_type')?.invalid"
                class="text-red-500 text-sm mt-1">
                Please select a user type
              </div>

            </div>
          </div>

          <div *ngIf="selectedUser !== 'Staff'">
            <div class="relative mb-6 lg:mb-8">
              <input type="text" id="email_username" formControlName="email"
                class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base xl:text-base text-444 font-normal bg-transparent rounded-lg border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                placeholder=" " />
              <label for="email_username"
                class="absolute text-sm lg:text-base xl:text-base text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Email
                / Username</label>
              <!-- Validation Error -->
              <div *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.invalid"
                class="text-red-500 text-sm mt-1">
                <span *ngIf="loginForm.get('email')?.errors?.['required']">*Email / Username is required</span>
                <span *ngIf="loginForm.get('email')?.errors?.['email']">*Enter a valid email</span>
              </div>
            </div>

            <div class="relative mb-4">
              <!-- Eye Icon -->
              <svg (click)="togglePasswordVisibility()"
                class="absolute right-[12px] top-[12px] w-5 h-5 lg:w-6 lg:h-6 cursor-pointer z-10"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#C19725">

                <!-- 🙈 Eye-slash (when password hidden) -->
                <path *ngIf="!showPassword" d="M2.1 3.51 1 4.62l3.06 3.06C2.74 9.08 1.73 10.46 1 12
       c1.73 3.89 6 7 11 7
       2.01 0 3.91-.44 5.63-1.23l3.25 3.25
       1.11-1.11L2.1 3.51zM12 17
       c-2.76 0-5-2.24-5-5
       0-.65.13-1.27.36-1.84l1.54 1.54
       c-.03.1-.05.21-.05.3
       0 1.66 1.34 3 3 3 .09 0 .19-.02.29-.03l1.54 1.54
       c-.56.23-1.18.36-1.83.36zm7.64-1.27
       L17.1 13.2
       c.08-.37.13-.75.13-1.2
       0-2.76-2.24-5-5-5-.44 0-.83.05-1.2.13L8.27 5.36
       C9.47 5.13 10.71 5 12 5
       c5 0 9.27 3.11 11 7
       -.68 1.53-1.69 2.91-3.36 3.73z" />

                <!-- 👁️ Eye (when password visible) -->
                <path *ngIf="showPassword" d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7
       c-1.73-3.89-6-7-11-7zm0 
       12c-2.76 0-5-2.24-5-5s2.24-5 5-5
       5 2.24 5 5-2.24 5-5 5zm0-8
       a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
              </svg>


              <!-- Password Input -->
              <input [type]="showPassword ? 'text' : 'password'" id="password" formControlName="password"
                class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base xl:text-base text-444 font-normal bg-transparent rounded-lg border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                placeholder=" " />

              <label for="password"
                class="absolute text-sm lg:text-base xl:text-base text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                Password
              </label>
              <!-- Validation Error -->
              <div *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid"
                class="text-red-500 text-sm mt-1">
                <span *ngIf="loginForm.get('password')?.errors?.['required']">*Password is required</span>
              </div>
            </div>

            <!-- >>>>>>> Stashed changes -->
            <div class="xs:col-span-1 sm:col-span-2">
              <div class="relative flex">
                <div
                  class="w-1/2 h-full bg-[#fff7e6] rounded-l-md flex items-center justify-between pl-3 text-base font-semibold text-[#c19725] select-none border-r border-dcdcdc">
                  <span class="tracking-widest text-2xl font-bold">{{ generatedCaptcha }}</span>
                  <button type="button" (click)="refreshCaptcha()"
                    class="block cursor-pointer px-3 py-2.5 text-base lg:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-l-md">
                    <i *ngIf="!isCaptchaLoading; else loadingCaptcha" class="fas fa-sync-alt"></i>
                    <ng-template #loadingCaptcha>
                      <i class="fas fa-spinner fa-spin"></i> <!-- Spinner Icon for Loader -->
                    </ng-template>
                  </button>
                </div>
                <div class="w-1/2">
                  <input formControlName="Captcha" type="text" id="Captcha" [(ngModel)]="userCaptcha"
                    class="block pb-3 pt-3 px-2.5 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-r-md border border-dcdcdc border-l-0 focus:outline-none focus:ring-0 focus:border-c19725 peer"
                    placeholder="Enter Captcha" />
                </div>
              </div>

              <div *ngIf="loginForm.controls['Captcha'].invalid &&
                (loginForm.controls['Captcha'].touched || loginForm.controls['Captcha'].dirty)">
                <span class="text-red-500 text-sm font-medium"
                  *ngIf="loginForm.controls['Captcha'].errors?.['required']">
                  *Captcha is required
                </span>
                <span class="text-red-500 text-sm font-medium"
                  *ngIf="loginForm.controls['Captcha'].errors?.['invalidCaptcha']">
                  *Enter a valid captcha code
                </span>
              </div>
            </div>
          </div>

          <div *ngIf="selectedUser === 'Staff'">
            <div class="relative mb-6 lg:mb-8">
              <input type="email" id="Owner_mail" formControlName="owner_email" placeholder=" "
                class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base xl:text-base text-444 font-normal bg-transparent rounded-lg border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
              <label for="Owner_mail"
                class="absolute text-sm lg:text-base xl:text-base text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Owner
                Mail
                / Username</label>
              <!-- Validation Error -->
              <div *ngIf="loginForm.get('owner_email')?.touched && loginForm.get('owner_email')?.invalid"
                class="text-red-500 text-sm mt-1">
                <span *ngIf="loginForm.get('owner_email')?.errors?.['required']">*Owner email is required</span>
                <span *ngIf="loginForm.get('owner_email')?.errors?.['email']">*Enter a valid email</span>
              </div>
            </div>

            <div class="relative mb-6 lg:mb-8">
              <input type="email" id="Staff Mail" placeholder=" " formControlName="email"
                class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base xl:text-base text-444 font-normal bg-transparent rounded-lg border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
              <label for="Staff Mail"
                class="absolute text-sm lg:text-base xl:text-base text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Staff
                Mail
                / Username</label>
              <!-- Validation Error -->
              <div *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.invalid"
                class="text-red-500 text-sm mt-1">
                <span *ngIf="loginForm.get('email')?.errors?.['required']">*Staff email is required</span>
                <span *ngIf="loginForm.get('email')?.errors?.['email']">*Enter a valid email</span>
              </div>
            </div>

            <div class="relative mb-4">
              <!-- Eye Icon -->
              <svg (click)="togglePasswordVisibility()"
                class="absolute right-[12px] top-[12px] w-5 h-5 lg:w-6 lg:h-6 cursor-pointer z-10"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#C19725">

                <!-- 🙈 Eye-slash (when password hidden) -->
                <path *ngIf="!showPassword" d="M2.1 3.51 1 4.62l3.06 3.06C2.74 9.08 1.73 10.46 1 12
       c1.73 3.89 6 7 11 7
       2.01 0 3.91-.44 5.63-1.23l3.25 3.25
       1.11-1.11L2.1 3.51zM12 17
       c-2.76 0-5-2.24-5-5
       0-.65.13-1.27.36-1.84l1.54 1.54
       c-.03.1-.05.21-.05.3
       0 1.66 1.34 3 3 3 .09 0 .19-.02.29-.03l1.54 1.54
       c-.56.23-1.18.36-1.83.36zm7.64-1.27
       L17.1 13.2
       c.08-.37.13-.75.13-1.2
       0-2.76-2.24-5-5-5-.44 0-.83.05-1.2.13L8.27 5.36
       C9.47 5.13 10.71 5 12 5
       c5 0 9.27 3.11 11 7
       -.68 1.53-1.69 2.91-3.36 3.73z" />

                <!-- 👁️ Eye (when password visible) -->
                <path *ngIf="showPassword" d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7
       c-1.73-3.89-6-7-11-7zm0 
       12c-2.76 0-5-2.24-5-5s2.24-5 5-5
       5 2.24 5 5-2.24 5-5 5zm0-8
       a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
              </svg>


              <!-- Password Input -->
              <input [type]="showPassword ? 'text' : 'password'" id="password" formControlName="password"
                class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base xl:text-base text-444 font-normal bg-transparent rounded-lg border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                placeholder=" " />

              <label for="password"
                class="absolute text-sm lg:text-base xl:text-base text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                Password
              </label>
              <!-- Validation Error -->
              <div *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid"
                class="text-red-500 text-sm mt-1">
                <span *ngIf="loginForm.get('password')?.errors?.['required']">*Password is required</span>
              </div>
            </div>
            <!-- >>>>>>> Stashed changes -->

            <!-- Reuse Captcha -->
            <div class="xs:col-span-1 sm:col-span-2">
              <div class="relative flex">
                <div
                  class="w-1/2 h-full bg-[#fff7e6] rounded-l-md flex items-center justify-between pl-3 text-base font-semibold text-[#c19725] select-none border-r border-dcdcdc">
                  <span class="tracking-widest text-2xl font-bold">{{ generatedCaptcha }}</span>
                  <button type="button" (click)="refreshCaptcha()"
                    class="block cursor-pointer px-3 py-2.5 text-base lg:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-l-md">
                    <i *ngIf="!isCaptchaLoading; else loadingCaptcha" class="fas fa-sync-alt"></i>
                    <ng-template #loadingCaptcha>
                      <i class="fas fa-spinner fa-spin"></i> <!-- Spinner Icon for Loader -->
                    </ng-template>
                  </button>
                </div>
                <div class="w-1/2">
                  <input formControlName="Captcha" type="text" id="Captcha" [(ngModel)]="userCaptcha"
                    class="block pb-3 pt-3 px-2.5 w-full text-sm lg:text-base text-555 font-normal bg-transparent rounded-r-md border border-dcdcdc border-l-0 focus:outline-none focus:ring-0 focus:border-c19725 peer"
                    placeholder="Enter Captcha" />
                </div>
              </div>

              <div *ngIf="loginForm.controls['Captcha'].invalid &&
                (loginForm.controls['Captcha'].touched || loginForm.controls['Captcha'].dirty)">
                <span class="text-red-500 text-sm font-medium"
                  *ngIf="loginForm.controls['Captcha'].errors?.['required']">
                  *Captcha is required
                </span>
                <span class="text-red-500 text-sm font-medium"
                  *ngIf="loginForm.controls['Captcha'].errors?.['invalidCaptcha']">
                  *Enter a valid captcha code
                </span>
              </div>
            </div>

          </div>

          <p>
            <a routerLink="/forgot-password"
              class="text-c19725 text-xs lg:text-sm font-normal capitalize block text-right">Forgot Password!</a>
          </p>
          <div class="flex items-center justify-center mt-4 md:mt-6">
            <button type="submit" [disabled]="isLoading"
              class="flex items-center justify-center cursor-pointer px-5 md:px-7 lg:px-10 w-[150px] lg:w-[300px] py-2 lg:py-3.5 text-base md:text-lg lg:text-2xl font-bold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-lg text-center disabled:opacity-70 disabled:cursor-not-allowed">
              <ng-container *ngIf="!isLoading; else loadingTemplate">
                Login
              </ng-container>
              <ng-template #loadingTemplate>
                <i class="fas fa-spinner fa-spin mr-2"></i> Loading...
              </ng-template>
            </button>
          </div>
          <!-- <p class="text-[#898989] font-normal text-sm lg:text-lg text-center mt-6">New here?<a routerLink="/signup"
              class="underline underline-offset-2 mx-1 font-bold text-c19725">Create an account</a>to get started!</p> -->
        </form>
      </div>

      <div class="hidden p-4 md:py-8 md:px-10 xl:py-10 xl:px-20 rounded-lg bg-white" id="styled-login-otp"
        role="tabpanel" aria-labelledby="login-otp-tab">
        <app-send-otp></app-send-otp>
      </div>

      <div class="hidden p-4 md:py-8 md:px-10 xl:py-10 xl:px-20 rounded-lg bg-white" id="styled-fingure-scan"
        role="tabpanel" aria-labelledby="fingure-scan-tab">
        <form>
          <!-- scanner connected -->
          <p class="text-center text-444 font-bold text-base md:text-xl xl:text-2xl mb-4 lg:mb-8">Connected to - Scanner
            458</p>

          <!-- scanner failed -->
          <!-- <p class="text-center text-[#BB0000] font-bold text-base md:text-xl xl:text-2xl mb-4 lg:mb-8">Failed to connect to Scanner 458.Try Again...!</p> -->

          <div class="mt-10 xl:mt-26">
            <!-- for finger scanning -->
            <img class="size-25 xl:size-37 mx-auto" src="/assets/images/login/scanning.gif" alt="fingure-scan">

            <!-- for scanning success -->
            <!-- <img class="size-25 xl:size-37 mx-auto" src="/assets/images/login/scan-success.gif" alt="fingure-scan"> -->

            <!-- for scanning failed -->
            <!-- <img class="size-25 xl:size-37 mx-auto" src="/assets/images/login/scan-failed.gif" alt="fingure-scan"> -->

          </div>
          <div class="flex items-center justify-center mt-8 md:mt-10">
            <button type="button" (click)="homePage()"
              class="block cursor-pointer px-5 md:px-7 lg:px-10 w-[150px] lg:w-[300px] py-2 lg:py-3.5 text-base md:text-lg lg:text-2xl font-bold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-lg text-center">Login</button>
          </div>
        </form>
      </div>
    </div>

  </div>
</div>